import {formMessageError} from "../message/formMessage";

export function checkEmailValid() {
    if (this.value == '') {
        this.setCustomValidity(formMessageError.email.empty);
    }
    else if(this.validity.typeMismatch){
        this.setCustomValidity(formMessageError.email.type);
    }
    else {
        this.setCustomValidity('');
    }
    return true;
}
